import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { BetType } from '@/types';

interface BetPlaceRequest {
  selection: string;
  /** Live market row ID when the submitted selection encodes game-specific picks. */
  marketSelection?: string;
  /** Games with inline selection controls manage their own betslip opening. */
  presentation?: 'inline';
  selections?: string[];
  /** One bet per entry, all with the same stake, e.g. Lottery's Random Bets digit sets. */
  batchSelections?: string[][];
  value: number | string;
  /** Optional Odds-field display override; never included in the bet request. */
  displayOdds?: number | string;
  betOn: BetType;
  displaySelection: string;
  minValue?: number;
  maxValue?: number;
}

interface InitialState {
  betDetails: BetPlaceRequest | null;
}

const initialState: InitialState = {
  betDetails: null,
};

export const betSlice = createSlice({
  name: 'bet',
  initialState,
  reducers: {
    setBetDetails: (state, action: PayloadAction<BetPlaceRequest>) => {
      state.betDetails = action.payload;
    },

    clearBetDetails: (state) => {
      state.betDetails = null;
    },
  },
});

export const { setBetDetails, clearBetDetails } = betSlice.actions;

export default betSlice.reducer;
